<template>
  <div class="project-list">
    <!-- 头部数量统计开始 -->
    <div class="list-header">
      <div class="count-item">
        <div class="item-content icon-all">
          <div class="item-num">
            {{ (projectNumInfo.countNotFinish + projectNumInfo.countStart + projectNumInfo.countFinish +
              projectNumInfo.countOverdue) || 0}}
          </div>
          <div class="item-status">{{ $t('projectDetailsV2.total') }}</div>
        </div>
      </div>
      <div class="count-item">
        <div class="item-content icon-not-start">
          <div class="item-num">{{ projectNumInfo.countNotFinish || 0 }}</div>
          <div class="item-status">{{ $t('projectDetailsV2.notBegin') }}</div>
        </div>
      </div>
      <div class="count-item">
        <div class="item-content icon-ongoing">
          <div class="item-num">{{ projectNumInfo.countStart || 0 }}</div>
          <div class="item-status">{{ $t('projectDetailsV2.inProgress') }}</div>
        </div>
      </div>
      <div class="count-item">
        <div class="item-content icon-completed">
          <div class="item-num">{{ projectNumInfo.countFinish || 0 }}</div>
          <div class="item-status">{{ $t('projectDetailsV2.completed') }}</div>
        </div>
      </div>
      <div class="count-item">
        <div class="item-content icon-overdue">
          <div class="item-num">{{ projectNumInfo.countOverdue || 0 }}</div>
          <div class="item-status">{{ $t('projectDetailsV2.overdue') }}</div>
        </div>
      </div>
    </div>
    <!-- 头部数量统计结束 -->
    <div class="list-content">
      <div class="content-header">
        <el-button type="primary" size="small" @click="jumpNewItem">{{ $t('projectV2.newProject') }}<i
            class="el-icon-circle-plus el-icon--right"></i></el-button>
        <div class="content-header-right">
          <el-button type="primary" size="small" class="file-manage" @click="jumpFileManage">
            {{ $t('fileManage.fileManage') }}</el-button>
          <el-popover :title="$t('projectV2.filter')" trigger="click" popper-class="project-screen" placement="bottom">
            <el-button class="search" size="small" slot="reference">
              <i></i>{{ $t('projectV2.filter') }}</el-button>
            <ul>
              <li>
                <el-input :placeholder="$t('newProjectV2.projectNameTip')" v-model="query.filter.projectName"
                  size="small">
                  <i slot="prefix" class="el-input__icon el-icon-search"></i>
                </el-input>
              </li>
              <li>
                {{ $t('newProjectV2.founder') }}
                <el-input size="small" v-model="query.filter.creatorName"
                  :placeholder="$t('newProjectV2.founderNameTip')"></el-input>
              </li>
              <li>
                {{ $t('newProjectV2.langPair') }}
                <el-select size="small" v-model="query.filter.lang_desc" :placeholder="$t('newProjectV2.langPairTip')">
                  <el-option v-for="(item, index) in langList" :key="index"
                    :label="$i18n.locale === 'zh' ? item.langDesc.replace('>', ' — ') : $langCase[item.sourceLang] + ' — ' + $langCase[item.targetLang]"
                    :value="item.langDesc"></el-option>
                </el-select>
              </li>
              <li>
                {{ $t('newProjectV2.domain') }}
                <el-select size="small" v-model="query.filter.domain_code" :placeholder="$t('newProjectV2.domainTip')">
                  <el-option v-for="(item, index) in domainList" :key="index"
                    :label="$i18n.locale === 'zh' ? item.name : $domainCase[item.code]" :value="item.code">
                  </el-option>
                </el-select>
              </li>
              <li>
                {{ $t('projectDetailsV2.status') }}
                <el-select size="small" v-model="query.filter.finish"
                  :placeholder="$t('projectV2.selectProjectStatus')">
                  <el-option v-for="(item, index) in finishList" :key="index" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </li>
              <li class="btn">
                <el-button @click="clearSearch">{{ $t('projectV2.clear') }}</el-button>
                <el-button type="primary" @click="getProject">{{ $t('projectV2.search') }}</el-button>
              </li>
            </ul>
          </el-popover>
        </div>
      </div>
      <div class="project-table">
        <el-table border height="100%" :data="projectList" v-loading="loading" :header-row-style="{
          'lineHeight': '25px'
        }" :row-style="{
            'height': '48px'
          }" header-row-class-name="customHeader">
          <el-table-column width="60" align='center' :label="$t('projectV2.index')">
            <template slot-scope="{ $index }">{{ $index + 1 }}</template>
          </el-table-column>
          <el-table-column align='center' :label="$t('projectV2.projectName')" :show-overflow-tooltip='true'
            class-name="project-name" min-width="110">
            <template slot-scope="{ row }"><span @click="jumpDetail(row)">{{ row.name }}</span></template>
          </el-table-column>
          <el-table-column align='center' :label="$t('projectV2.langDesc')" :show-overflow-tooltip='true'>
            <template slot-scope="{ row }">
              <template v-if="$i18n.locale === 'zh'">{{ row.langDesc.replace('>', ' — ') }}</template>
              <template v-else>{{ `${$langCase[row.sourceLang]} — ${$langCase[row.targetLang]}` }}</template>
            </template>
          </el-table-column>
          <el-table-column align='center' :label="$t('projectV2.domain')" :show-overflow-tooltip='true'>
            <template slot-scope="{ row }">{{ $i18n.locale === 'zh' ? row.domain :
              $domainCase[row.domainCode]}}</template>
          </el-table-column>
          <el-table-column :label="$t('projectV2.creator')" align='center' :show-overflow-tooltip='true'
            prop="pmUser"></el-table-column>
          <el-table-column :label="$t('projectV2.limitTime')" :show-overflow-tooltip='true' align='center'>
            <template slot-scope="{ row }">
              <span
                :class="{ 'overdue': (new Date() > new Date(row.deliveryTime) && row.finish !== 1) }">{{ row.deliveryTime }}</span>
            </template>
          </el-table-column>
          <el-table-column :label="$t('projectV2.progress')" align='center' prop="progress">
            <template slot-scope="{ row }">
              <el-progress :percentage="row.progress"></el-progress>
            </template>
          </el-table-column>
          <el-table-column :label="$t('projectV2.state')" align='center' :show-overflow-tooltip='true'
            :width="$i18n.locale === 'zh' ? '100' : '160'">
            <template slot-scope="{ row }">
              <!-- <span :class="`project-status status-${finishFormat(row)}`"></span>{{ statusFormat(row) }} -->
              <span :class="`project-status status-${finishFormat(row)}`">{{ statusFormat(row) }}</span>
            </template>
          </el-table-column>
          <el-table-column :label="$t('projectV2.operation')" align='center' class-name="operate" width="230">
            <template slot-scope="{ row }">
              <el-tooltip effect="dark" :content="$t('projectV2.details')" placement="top">
                <i class="icon-view" @click="jumpDetail(row)"></i>
              </el-tooltip>

              <el-tooltip effect="dark" :content="$t('projectV2.setUp')" placement="top">
                <i class="icon-setting" @click="jumpSetting(row)"></i>
              </el-tooltip>

              <el-tooltip effect="dark" :content="$t('projectV2.statistics')" placement="top">
                <i class="icon-statistics" @click="jumpStatistics(row.id)"></i>
              </el-tooltip>

              <el-tooltip effect="dark" :content="$t('projectV2.download')" placement="top">
                <el-popover trigger="click" placement="bottom" popper-class="project-download"
                  :ref="`popover-${row.id}`" @after-leave="downloadHide" :visible-arrow='false'>
                  <el-cascader-panel v-model="downloadStr" :props='props' :options="fn(options, row.projectProcessType)"
                    @change='downloadReport($event, row)'>
                  </el-cascader-panel>
                  <i class="icon-export" slot="reference"></i>
                </el-popover>
              </el-tooltip>

              <el-tooltip effect="dark" :content="$t('projectV2.delete')" placement="top">
                <i class="icon-del" @click="handleDel(row.id)"></i>
              </el-tooltip>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="project-pagination">
        <el-pagination background layout="prev, pager, next, sizes" :pager-count="5" :current-page="query.page"
          :page-sizes="[10, 20, 30, 40]" :page-size="query.rows" :total="tableDataInfo.totalRows"
          @size-change="handleSizeChange" @current-change="handleCurrentChange">
        </el-pagination>
      </div>
    </div>

    <DelDialog Dialog width="480px" :dialogVisible="delVisible" :dialogType="'delete'" @handleClose="closeDel"
      @handleConfirm="delProject">{{ $t('projectV2.delProjectTip') }}
    </DelDialog>

    <div v-show="isDownloadLoading" id="downloadLoadingBox">
      <div class="loadingMain">
        <i class="el-icon-loading"></i>
        <p>{{ $t('project.downloadProgress') }}....</p>
      </div>
    </div>
  </div>
</template>

<script>
import DelDialog from '@/components/delDialog';

import {
  queryDomain,
  queryLanguage,
  deleteProject,
  myProjectDataQuery,
  getTransProjectNum
} from '@/services/myProjectApi';

export default {
  name: 'ProjectList',
  components: {
    DelDialog,
  },
  data() {
    return {
      props: {
        expandTrigger: 'hover',
        emitPath: false,
      },
      downloadStr: '',
      options: [
        { label: this.$t('projectV2.original'), value: 'original' },
        {
          label: this.$t('projectV2.translate'),
          value: 'translate',
          children: [
            { label: this.$t('projectV2.translation'), value: 'translate-translation' },
            { label: this.$t('projectV2.contrast'), value: 'translate-contrast' }
          ]
        },
        {
          label: this.$t('projectV2.examine'),
          value: 'proofread',
          children: [
            { label: this.$t('projectV2.translation'), value: 'proofread-translation' },
            { label: this.$t('projectV2.contrast'), value: 'proofread-contrast' }
          ]
        },
        {
          label: this.$t('projectV2.review'),
          value: 'review',
          children: [
            { label: this.$t('projectV2.translation'), value: 'review-translation' },
            { label: this.$t('projectV2.contrast'), value: 'review-contrast' }
          ]
        },
        { label: this.$t('projectV2.revise'), value: 'modify' },
        { label: this.$t('projectV2.archive'), value: 'TMXreport' },
        { label: this.$t('projectV2.qareport'), value: 'QAreport' },
        { label: this.$t('projectV2.xlfreport'), value: 'XLFreport' },
      ],
      query: {
        filter: {
          finish: '',
          lang_desc: '',
          domain_code: '',
          projectName: '',
          creatorName: '',
        },
        page: 1,
        rows: 10,
        sort: { create_time: "desc" },
      },
      loading: true,
      projectList: [],
      domainList: [],
      langList: [],
      finishList: [
        { label: this.$t('jobManagementV2.notStarted'), value: 0 },
        { label: this.$t('jobManagementV2.ongoing'), value: 2 },
        { label: this.$t('jobManagementV2.completed'), value: 1 },
        { label: this.$t('jobManagementV2.overdue'), value: 3 },
        { label: this.$t('jobManagementV2.overdueComplete'), value: 4 },
        { label: this.$t('projectDetailsV2.accepted'), value: 5 },
      ],
      tableDataInfo: {
        totalRows: 0,
        totalPage: 0,
      },
      delVisible: false,
      delProjectId: 0,
      isDownloadLoading: false,
      projectNumInfo: {},
    }
  },
  mounted() {
    this.getProjectList();
    this.getProjectNum();
    this.getLangPair();
    this.getDomain();
  },
  methods: {
    // 获取项目列表
    async getProjectList() {
      Object.keys(this.query.filter).forEach(item => {
        if (this.query.filter[item] === '' || this.query.filter[item] === undefined || this.query.filter[item] === null || this.query.filter[item] === 'null') {
          delete this.query.filter[item];
        }
      });
      Reflect.set(this.query.filter, 'company_code', (localStorage.myCompanyCode));
      myProjectDataQuery(this.query).then(({ list, totalRows, success, status }) => {
        if (success && status === 200) {
          this.tableDataInfo.totalRows = totalRows;
          this.projectList = list;
        }
      }).finally(() => {
        this.loading = false;
      });
    },
    // 获取语言方向
    async getLangPair() {
      const { result, success } = await queryLanguage({});
      if (!success) return;
      this.langList = result;
    },
    // 获取领域
    async getDomain() {
      const { result, success } = await queryDomain({});
      if (!success) return;
      this.domainList = result;
    },
    // 删除项目
    async delProject() {
      this.delVisible = false;
      let { success } = await deleteProject({ id: this.delProjectId });
      if (success) {
        this.$message.closeAll();
        this.$message.success(this.$t('projectV2.success'));
        if (this.query.page > 1 && this.projectList.length === 1) {
          this.query.page--;
        }
        this.getProjectList();
        this.getProjectNum();
      }
      // else {
      //   this.$message.warning(this.$t('projectV2.error'));
      // }
    },
    // 获取顶部数量
    async getProjectNum() {
      let { success, result } = await getTransProjectNum({});
      if (!success) { return; }
      this.projectNumInfo = result;
    },
    // 下载隐藏
    downloadHide() {
      this.downloadStr = '';
    },
    // 根据流程更改下载栏目
    fn(options, type) {
      if (type === 1) {
        return [
          { label: this.$t('projectV2.original'), value: 'original' },
          {
            label: this.$t('projectV2.translate'), value: 'translate', children: [
              { label: this.$t('projectV2.translation'), value: 'translate-translation' },
              { label: this.$t('projectV2.contrast'), value: 'translate-contrast' }
            ]
          },
          { label: this.$t('projectV2.revise'), value: 'modify' },
          { label: this.$t('projectV2.archive'), value: 'TMXreport' },
          { label: this.$t('projectV2.qareport'), value: 'QAreport' },
          { label: this.$t('projectV2.xlfreport'), value: 'XLFreport' },
        ];
      } else if (type === 2) {
        return [
          { label: this.$t('projectV2.original'), value: 'original' },
          {
            label: this.$t('projectV2.translate'), value: 'translate', children: [
              { label: this.$t('projectV2.translation'), value: 'translate-translation' },
              { label: this.$t('projectV2.contrast'), value: 'translate-contrast' }
            ]
          },
          {
            label: this.$t('projectV2.examine'), value: 'proofread', children: [
              { label: this.$t('projectV2.translation'), value: 'proofread-translation' },
              { label: this.$t('projectV2.contrast'), value: 'proofread-contrast' }
            ]
          },
          { label: this.$t('projectV2.revise'), value: 'modify' },
          { label: this.$t('projectV2.archive'), value: 'TMXreport' },
          { label: this.$t('projectV2.qareport'), value: 'QAreport' },
          { label: this.$t('projectV2.xlfreport'), value: 'XLFreport' },
        ];
      }
      return options;
    },
    // 删除项目弹窗
    handleDel(id) {
      this.delVisible = true;
      this.delProjectId = id;
    },
    // 关闭弹窗
    closeDel() {
      this.delVisible = false;
    },
    // 搜索
    getProject() {
      this.query.page = 1;
      this.query.rows = 10;
      this.getProjectList();
    },
    // 清空搜索
    clearSearch() {
      this.query = {
        filter: {
          finish: '',
          lang_desc: '',
          domain_code: '',
          projectName: '',
          creatorName: '',
        },
        page: 1,
        rows: 10,
        sort: { create_time: "desc" },
      };
      this.getProjectList();
    },
    // 跳转详情
    jumpDetail(row) {
      this.$router.push({
        name: 'ProjectDetail',
        query: { id: row.id }
      })
    },
    // 跳转新建项目
    jumpNewItem() {
      this.$router.push({
        name: 'NewItem',
      })
    },
    jumpFileManage() {
      this.$router.push({
        name: 'fileManage',
      })
    },
    // 跳转设置
    jumpSetting(row) {
      this.$router.push({
        name: 'DetailSetting',
        query: { id: row.id }
      })
    },
    // 跳转统计
    jumpStatistics(id) {
      this.$router.push({
        name: 'ProjectStatistics',
        query: { id }
      })
    },
    // 页码大小变化
    handleSizeChange(val) {
      this.loading = true;
      this.query.rows = val;
      this.handleCurrentChange(1)
    },
    // 选中页码变化
    handleCurrentChange(val) {
      this.loading = true;
      this.query.page = val;
      this.getProjectList();
    },
    // 项目状态
    statusFormat(row) {
      if (row.finish === 0) {
        if (new Date() > new Date(row.deliveryTime)) {
          return this.$t('projectDetailsV2.overdue');
        }
        return this.$t('projectDetailsV2.notBegin');
      } else if (row.finish === 2) {
        if (new Date() > new Date(row.deliveryTime)) {
          return this.$t('projectDetailsV2.overdue');
        }
        return this.$t('projectDetailsV2.inProgress');
      } else if (row.finish === 1) {
        if (new Date(row.finishTime) > new Date(row.deliveryTime)) {
          return this.$t('projectDetailsV2.overdueComplete');
        }
        return this.$t('projectDetailsV2.completed');
      } else if (row.finish === 3) {
        return this.$t('projectDetailsV2.overdue');
      } else if (row.finish === 4) {
        return this.$t('projectDetailsV2.overdueComplete');
      } else if (row.finish === 5) {
        return this.$t('projectDetailsV2.accepted');
      }
    },
    finishFormat(row) {
      if (row.finish === 0) {
        if (new Date() > new Date(row.deliveryTime)) {
          return 3;
        }
        return 0;
      } else if (row.finish === 2) {
        if (new Date() > new Date(row.deliveryTime)) {
          return 3;
        }
        return 2;
      } else if (row.finish === 1) {
        if (new Date(row.finishTime) > new Date(row.deliveryTime)) {
          return 4;
        }
        return 1;
      } else if (row.finish === 5) {
        return 5
      } else {
        return row.finish;
      }
    },
    // 下载
    downloadReport(value, row) {
      let id = row.id;
      let type = null;
      this.$refs[`popover-${id}`].doClose();
      switch (value) {
        case 'original':
          type = 6;
          this.downloadFileName = row.name + '（原文）.zip';
          break;
        case 'translate-translation':
          type = 1;
          this.downloadFileName = row.name + '（翻译译文）.zip';
          break;
        case 'translate-contrast':
          type = 2;
          this.downloadFileName = row.name + '（翻译原译对照）.zip';
          break;
        case 'proofread-translation':
          type = 3;
          this.downloadFileName = row.name + '（审校译文）.zip';
          break;
        case 'proofread-contrast':
          type = 4;
          this.downloadFileName = row.name + '（审校原译对照）.zip';
          break;
        case 'review-translation':
          type = 11;
          this.downloadFileName = row.name + '（复审译文）.zip';
          break;
        case 'review-contrast':
          type = 12;
          this.downloadFileName = row.name + '（复审原译对照）.zip';
          break;
        case 'modify':
          type = 5;
          this.downloadFileName = row.name + '（修订痕迹）.zip';
          break;
        case 'TMXreport':
          type = 7;
          this.downloadFileName = row.name + '（TMX文档）.zip';
          break;
        case 'QAreport':
          type = 8;
          this.downloadFileName = row.name + '（QA报告）.zip';
          break;
        case 'XLFreport':
          type = 10;
          this.downloadFileName = row.name + '（XLF文档）.zip';
          break;
        default:
          break;
      }
      if (type !== 6 && row.finish === 0) {
        this.$message.closeAll();
        this.$message.warning(this.$t('projectV2.porjectNotBeginNotDownload'))
        return;
      }
      this.asynchronizationDownload(`/api/v1//file/exportAsyncProject?type=${type}&projectId=${id}`);
    },
    // 下载（异步）
    async asynchronizationDownload(url) {
      const response = await this.catReq1Service(url, {}, 'get')
      if (response.resultCode === "1") {
        const result = response.result;
        if (response.result.percent == 100) {
          this.downloadServerFile(result.fileName, result.downloadUrl);
        } else {
          this.isDownloadLoading = true;
          this.getDownloadAsyncResult(result.taskKey)
        }
      }
    },
    // 下载指定的服务文件
    downloadServerFile(fileName, filePath) {
      let link = document.createElement("a");
      link.style.display = "none";
      link.href = "/cat" + `/api/v1/file/downloadServerFile?fileName=${this.downloadFileName}&filePath=${filePath}`;
      link.setAttribute("download", fileName);
      document.body.appendChild(link);
      link.click();
    },
    // 下载轮询
    async getDownloadAsyncResult(taskKey) {
      var setItem = setInterval(async () => {
        const response = await this.catReq1Service('/api/v1/file/getDownloadAsyncResult', { taskKey }, 'get')
        if (response.resultCode === "1") {
          const result = response.result;
          // this.downloadPercent = result.percent;
          if (result.percent == 100) {
            clearInterval(setItem);
            setItem = null;
            this.isDownloadLoading = false;
            // this.downloadPercent = 0;
            this.downloadServerFile(result.fileName, result.downloadUrl)
          }
        } else {
          clearInterval(setItem);
          setItem = null;
          // this.downloadPercent = 0;
          this.isDownloadLoading = false;
        }
      }, 2000);
    },
  }
}
</script>

<style lang="less" scoped>
@import "./assets/style.less";
</style>

<style lang="less">
@media screen and (max-width: 1260px) {
  .project-list {
    .el-progress-bar {
      display: none;
    }

    .el-progress__text {
      margin: 0;
    }
  }
}

.project-screen {
  .el-popover__title {
    font-weight: bold;
  }

  ul {
    width: 200px;

    li+li {
      color: #454545;
      text-align: left;
      margin-top: 12px;
    }

    li {
      .el-select {
        width: 100%;

        .el-input {
          width: 100%;
        }
      }

      .el-button+.el-button {
        margin-left: 20px;
      }

      .el-button {
        padding: 0 20px;
        height: 32px;
        line-height: 32px;
      }

      .el-button--default {
        color: #0078fc;
        border: 1px solid #0078fc;
      }
    }

    .btn {
      text-align: center;
    }
  }
}

.project-download {
  padding: 0;
  transform: translate(-60%, -50%);

  .el-cascader-panel {
    .el-cascader-menu {
      min-width: 130px;

      .el-scrollbar__wrap {
        height: auto;

        ul {
          li {
            height: 32px;

            .el-icon-check {
              display: none;
            }

            .el-cascader-node__label {
              line-height: 32px;
            }
          }
        }
      }
    }

    .el-cascader-menu:last-child {
      .el-scrollbar__wrap {
        overflow-x: auto;
      }
    }

    .el-cascader-menu:first-child {
      .el-scrollbar__wrap {
        overflow-x: scroll;
      }
    }
  }
}
</style>